import { useEffect, useRef } from "react";
import { BaseVideoControls } from "../../../../../../../components/app-video/video-models";
import styles from "./VideoProgressControl.module.scss";

interface VideoProgressControlProps extends BaseVideoControls {
  onNext: () => void;
}

export function VideoProgressControl({
  state,
  setAction,
  onNext
}: VideoProgressControlProps) {
  const trackEl = useRef<HTMLDivElement>();
  const animatedTrackEl = useRef<HTMLDivElement>();

  const getProgressPercent = (current: number, duration: number) => {
    if (current < 0 || duration <= 0) return 0;
    return (current / duration) * 100;
  };

  useEffect(() => {
    if (!state?.duration || !state?.currentTime || !trackEl.current) return;
    const progressPercent = getProgressPercent(
      state.currentTime,
      state.duration
    );
    trackEl.current.style.width = progressPercent + "%";
  }, [state.currentTime, state.duration]);

  useEffect(() => {
    if (!state || state.isAbort) return;
    if (
      (state.currentTime === state.duration &&
        state.currentTime !== -1 &&
        state.duration !== -1) ||
      trackEl.current.style.width === "100%"
    ) {
      setAction({
        action: "end"
      });
    }
  }, [setAction, state, state.currentTime, state.duration, state.isAbort]);

  return (
    <div className={styles.progressSlider}>
      <div className={styles.background} />

      <div className={styles.track} ref={trackEl} />
    </div>
  );
}
